<template>
  <loading
    :active="isLoading"
    :is-full-page="true"
    :height="100"
    :width="100"
    class="t-setting-sendmail-edit__loading"
  ></loading>
  <div v-if="screenload" :class="componentClassName">
    <a-page-heading>メール配信管理</a-page-heading>
    <m-section>
      <m-action-card title="メールの設定" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-sendmail-edit__form" @submit.prevent="handleDialogSendMail">
          <div class="t-settings-sendmail-add__fields">
            <div class="t-setting-sendmail-edit__row">
              <div class="t-setting-sendmail-edit__col__left">
                <m-form-input label="宛先">
                  <a-button
                    id="sendChoiceBtn"
                    :inline="true"
                    icon="plus"
                    variant="fill"
                    color="primary"
                    size="small"
                    label="送信先設定"
                    :disabled="isClosed || readOnly"
                    @click="handleSendChoiceButton()"
                  />
                </m-form-input>
              </div>
              <div class="t-setting-sendmail-edit__col__right">
                <m-form-input label="&nbsp;">
                  <textarea
                    id="sendMailList"
                    v-model="sendMailList"
                    class="a-text-field__input"
                    placeholder=""
                    rows="9"
                    :disabled="true"
                  ></textarea>
                </m-form-input>
              </div>
            </div>
            <m-form-input label="件名">
              <a-text-field
                id="sendSubject"
                v-model="sendSubject"
                type="text"
                placeholder="入力してください"
                maxlength="100"
                required
                :disabled="isClosed || readOnly"
              />
            </m-form-input>
            <m-form-input label="本文">
              <textarea
                id="sendMailBody"
                v-model="sendMailBody"
                :class="[
                  readOnly ? 'a-text-field__input t-setting-sendmail-edit__text__fieldinput' : 'a-text-field__input',
                ]"
                placeholder=""
                maxlength="2000"
                rows="10"
                :readonly="isClosed || readOnly"
              ></textarea>
            </m-form-input>
          </div>
          <m-form-action-buttons>
            <template v-if="!readOnly">
              <a-button
                id="store"
                variant="block"
                color="primary"
                :disabled="isClosed || !flagAllButtonEnable"
                @click="handleDialogSendMail"
                >送信</a-button
              >
            </template>
            <a-button
              id="cancel"
              variant="outlined"
              color="primary"
              :disabled="!flagAllButtonEnable"
              @click="handleCancelClick"
              >キャンセル</a-button
            >
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      v-if="sendMailConfDialogVisible"
      id="settingTrialEdit_removeModal"
      v-model:visible="sendMailConfDialogVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelSendMail"
    >
      <a-text>
        <!-- eslint-disable -->
        <span v-html="sendMailConfMessageText" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="infoDeleteNo"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleCancelSendMail"
        />
        <a-button
          id="infoDeleteYes"
          variant="block"
          color="primary"
          label="送信"
          size="small"
          @click="handleConfirmSendMail"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingTrialEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="buttonResultOk"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal(next)"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';
import Loading from 'vue-loading-overlay';

export default {
  name: 't-setting-sendmail-edit',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormInput,
    ATextField,
    Loading,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      isLoading: false,
      isClosed: false,
      sendMailConfDialogVisible: false,
      flagAllButtonEnable: true,
      sendMailConfMessageBaseText:
        '以下の内容でメールを送信します。<br />よろしいですか？<br />\
<br />\
<strong>送信件数</strong><br />\
{{ sendCount }}<br />\
<br />\
<strong>件名</strong><br />\
{{ sendSubject }}<br />\
<br />\
<strong>本文</strong><br />\
{{ sendMailBody }}',
      sendCount: 0,
      sendSubject: '',
      sendMailBody: '',
      modalSubject: '',
      modalMailBody: '',
      readOnly: false,
      sendID: '',
      contractdata: {},
      sendMailList: '',
      screenload: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-sendmail-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    if (this.authInfo === 'soOperator') {
      this.$router.push({ path: '/permission-denied' });
    }

    this.flagAllButtonEnable = true;

    this.sendMailList = typeof this.$route.params.sendMailList !== 'undefined' ? this.$route.params.sendMailList : '';
    this.sendSubject = typeof this.$route.params.sendSubject !== 'undefined' ? this.$route.params.sendSubject : '';
    this.sendMailBody = typeof this.$route.params.sendMailBody !== 'undefined' ? this.$route.params.sendMailBody : '';

    // メール送信内容を取得してセット
    this.sendID = this.$route.query.sendID;
    if (this.sendID) {
      this.readOnly = true;
      this.postRequest('/sendmail/getSendMailData', { sendID: this.sendID })
        .then(e => {
          if (e.status === 'success') {
            this.sendSubject = e.data[0].mailSubject;
            this.sendMailBody = e.data[0].mailBody;
            this.sendMailList = e.data[0].sendList;
          } else {
            this.isClosed = true;
            this.showErrorModal(messageContent.requireTry('メールの設定'));
          }
        })
        .catch(error => {
          console.log(error);
          this.isClosed = true;
          this.showErrorModal(messageContent.requireTry('メールの設定'));
        });
    }
    this.screenload = true;
  },
  methods: {
    handleCancelClick() {
      this.$router.push('/sendmaillist');
    },
    handleDialogSendMail: async function () {
      // 入力チェック
      const arrCheckInput = { 件名: this.sendSubject, 本文: this.sendMailBody, 宛先: this.sendMailList };

      for (const key in arrCheckInput) {
        if (arrCheckInput[key] === '') {
          this.showErrorModal(messageContent.requireInput(key));
          return;
        }

        if (this.hasSpecialCharacterInObject({ keyWord: arrCheckInput[key].replace(/\r?\n/g, '') })) {
          this.showErrorModal(key + 'に' + messageContent.hasSpecialCharacter);
          return;
        }
      }

      // 送信件数
      this.sendCount = this.sendMailList.split(',').length - 1;

      // 003300情報取得
      await this.postRequest('/companymgmt/search', { companyID: POINT })
        .then(e => {
          if (e.status === 'success') {
            this.contractdata = e.data;
          } else {
            this.isClosed = true;
            this.isLoading = false;
            this.showErrorModal(messageContent.requireTry('メールの設定'));
          }
        })
        .catch(error => {
          console.log(error);
          this.isClosed = true;
          this.isLoading = false;
          this.showErrorModal(messageContent.requireTry('メールの設定'));
        });

      // 確認モーダル用に文字列を置き換える
      this.modalSubject = this.sendSubject;
      this.modalMailBody = this.sendMailBody;
      for (const key in this.contractdata) {
        if (key === 'adminName' || key === 'adminKanaName') {
          this.contractdata[key] = this.contractdata[key].replace('_', ' ');
        }
        this.modalSubject = this.modalSubject.replace('%%' + key + '%%', this.contractdata[key]);
        this.modalMailBody = this.modalMailBody.replace('%%' + key + '%%', this.contractdata[key]);
        if (this.modalSubject.indexOf('%%') === -1 && this.modalMailBody.indexOf('%%') === -1) break;
      }

      // 確認モーダル用テキスト作成
      const arrSetMsg = { sendCount: this.sendCount, sendSubject: this.modalSubject, sendMailBody: this.modalMailBody };
      this.sendMailConfMessageText = this.convertMessage(this.sendMailConfMessageBaseText, arrSetMsg);

      this.flagAllButtonEnable = false;
      this.sendMailConfDialogVisible = true;
    },
    handleConfirmSendMail: async function () {
      this.isLoading = true;

      // 一斉メール送信処理
      await this.postRequest('/sendmail/sendMassEmail', {
        sendMailList: this.sendMailList,
        sendSubject: this.sendSubject,
        sendMailBody: this.sendMailBody.replace(/\n/g, '%%n%%'),
      })
        .then(e => {
          if (e.status === 'success') {
            this.$router.push('/sendmaillist');
          } else {
            this.isLoading = false;
            if (e.msg) {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.requireTry('メールの設定'));
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          this.showErrorModal(messageContent.requireTry('メールの設定'));
        });
    },
    handleCloseModal(next) {
      if (next) {
        this.$router.push(next);
      }
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      this.flagAllButtonEnable = true;
    },
    handleCancelSendMail() {
      this.isLoading = false;
      this.sendMailConfDialogVisible = false;
      this.flagAllButtonEnable = true;
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, next = '') {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.next = next;
    },
    replaceSpecialCharacter: function (string) {
      if (typeof string !== 'string') return string;
      string = string.replace(/&|'|"|<|>/g, '');
      return string.replace(/\r?\n|\r/g, '<br />');
    },
    // 確認モーダルテキストを変換
    convertMessage(message, arrSetMsg) {
      let newMessage = message;

      for (const key in arrSetMsg) {
        newMessage = newMessage.replace('{{ ' + key + ' }}', this.replaceSpecialCharacter(arrSetMsg[key]));
      }
      return newMessage;
    },
    handleSendChoiceButton() {
      this.$router.push({
        name: 'SendChoiceList',
        params: {
          sendMailList: this.sendMailList,
          sendSubject: this.sendSubject,
          sendMailBody: this.sendMailBody,
        },
      });
    },
  },
};
</script>
